import { render, staticRenderFns } from "./pagination2.vue?vue&type=template&id=ad4b56ea&scoped=true&"
import script from "./pagination2.vue?vue&type=script&lang=js&"
export * from "./pagination2.vue?vue&type=script&lang=js&"
import style0 from "./pagination2.vue?vue&type=style&index=0&id=ad4b56ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4b56ea",
  null
  
)

export default component.exports